import { render, staticRenderFns } from "./SalesChart.vue?vue&type=template&id=7efd95f4&scoped=true&lang=pug&"
import script from "./SalesChart.vue?vue&type=script&lang=js&"
export * from "./SalesChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesChart.vue?vue&type=style&index=0&id=7efd95f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efd95f4",
  null
  
)

export default component.exports